import { render, staticRenderFns } from "./regionalSales_page.vue?vue&type=template&id=f4cb5678&scoped=true"
import script from "./regionalSales_page.vue?vue&type=script&lang=js"
export * from "./regionalSales_page.vue?vue&type=script&lang=js"
import style0 from "./regionalSales_page.vue?vue&type=style&index=0&id=f4cb5678&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cb5678",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4cb5678')) {
      api.createRecord('f4cb5678', component.options)
    } else {
      api.reload('f4cb5678', component.options)
    }
    module.hot.accept("./regionalSales_page.vue?vue&type=template&id=f4cb5678&scoped=true", function () {
      api.rerender('f4cb5678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/regionalSales_page.vue"
export default component.exports